module.exports = __webpack_public_path__ + "g.no2.381054d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/g.no2.jpg
// module id = wMMg
// module chunks = 0